module.exports = __webpack_public_path__ + "img/banner-mobile2.41f79585.png";